<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="car-recognition-tab" data-bs-toggle="pill" data-bs-target="#car-recognition"
            type="button" role="tab" aria-controls="car-recognition" aria-selected="true"> 即時_進出車輛辨識紀錄 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="estimate-people-tab" data-bs-toggle="pill" data-bs-target="#estimate-people" 
            type="button" role="tab" aria-controls="estimate-people" aria-selected="false">即時_車流推估人流 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="day-report-tab" data-bs-toggle="pill" data-bs-target="#day-report" 
            type="button" role="tab" aria-controls="day-report" aria-selected="false">統計_日報 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="month-report-tab" data-bs-toggle="pill" data-bs-target="#month-report" 
            type="button" role="tab" aria-controls="month-report" aria-selected="false">統計_月報 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="cross-region-tab" data-bs-toggle="pill" data-bs-target="#cross-region" 
            type="button" role="tab" aria-controls="cross-region" aria-selected="false">跨景區比較 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <car-recognition></car-recognition>
        <estimate-people-flow></estimate-people-flow>        
        <day-report></day-report>
        <month-report></month-report>
        <cross-region></cross-region>
      </div>
    </div>
  </main>
</template>

<script>
import carRecognition from './carRecognition.vue';
import estimatePeopleFlow from './estimatePeopleFlow.vue';
import dayReport from './dayReport.vue';
import monthReport from './monthReport.vue';
import crossRegion from './crossRegion.vue'
import CrossRegion from './crossRegion.vue';



export default {
  components: { carRecognition, estimatePeopleFlow, dayReport,monthReport, CrossRegion },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
